import React from 'react'
import { useDispatch } from 'react-redux'

import { sendMessages } from 'ducks/concurrency'
import { useModal, useSnackbar } from 'hooks'

const useSendTestsInvitationsMutations = () => {
  const dispatch = useDispatch()

  const handleSendReminders = React.useCallback(
    (
      { candidates, projectId, workspaceId },
      { onShowSnackbar, onSuccess, postSuccessAction },
    ) => {
      dispatch(
        sendMessages(
          { candidates, projectId, workspaceId },
          { onShowSnackbar, onSuccess, postSuccessAction },
        ),
      )
    },
    [dispatch],
  )

  return {
    handleSendReminders,
  }
}

export const useSendTestsRemindersModal = (state, handlers) => {
  const { projectId, workspaceId } = state
  const { handleSetCandidate } = handlers

  const handleReset = React.useCallback(() => {
    handleSetCandidate(null)
  }, [handleSetCandidate])

  const { handleClose, handleOpen, isOpen } = useModal()

  const {
    handlers: { handleShowSnackbar },
  } = useSnackbar()

  const { handleSendReminders } = useSendTestsInvitationsMutations()

  const handleSendTestsRemindersModalClose = React.useCallback(() => {
    handleClose()
    handleReset()
  }, [handleClose, handleReset])

  const handleSendTestsRemindersModalConfirm = React.useCallback(
    ({ candidates }, { onSuccess }) => {
      handleSendReminders(
        { candidates, projectId, workspaceId },
        {
          onShowSnackbar: handleShowSnackbar,
          onSuccess: () => {
            onSuccess()
            handleReset()
          },
        },
      )
      handleClose()
    },
    [
      projectId,
      workspaceId,
      handleClose,
      handleReset,
      handleSendReminders,
      handleShowSnackbar,
    ],
  )
  return {
    handleSendTestsRemindersModalClose,
    handleSendTestsRemindersModalConfirm,
    handleSendTestsRemindersModalOpen: handleOpen,
    isSendTestsRemindersModalOpen: isOpen,
  }
}
